import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectModel } from '../../models/select-model';
import { DepartmentDto } from '../../models/dictionaries/departmentDTO';
import { FormFactory } from '../forms/form-factory';
import { AddressDto } from '../../models/dictionaries/addressDTO';

@Component({
  selector: 'app-add-department-dialog',
  templateUrl: './add-department-dialog.component.html',
  styleUrls: ['./add-department-dialog.component.scss'],
})
export class AddDepartmentDialogComponent implements OnInit {
  useTranslation: boolean;
  name: string;

  form: UntypedFormGroup;

  constructor(
    private dialogRef: MatDialogRef<AddDepartmentDialogComponent>,
    formFactory: FormFactory,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; useTranslation?: boolean }
  ) {
    this.name = data.name;
    this.useTranslation = data.useTranslation === true;
    this.form = formFactory.getDepartmentForm().forAdd();
  }

  ngOnInit() {}

  save() {
    if (!this.form.valid) {
      return;
    }
    var formValues = this.form.getRawValue();
    var model = new DepartmentDto(formValues);
    var result = model;
    this.dialogRef.close(result);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
